<label
  class="app-radio-wrapper"
  [ngClass]="[
    isChecked ? 'app-radio-wrapper--checked' : '',
    disabled ? 'app-radio-wrapper--disabled' : '',
    customClass
  ]"
  (click)="select($event)"
>
  <div class="app-radio__control">
    <span class="app-radio__circle">
      <span class="app-radio__dot"></span>
    </span>
  </div>

  <div class="app-radio__content" *ngIf="label || description">
    <span *ngIf="label" class="app-radio__label">{{ formattedLabel }}</span>
    <span *ngIf="description" class="app-radio__description">{{ description }}</span>
    <ng-content></ng-content>
  </div>
</label>



